import React, { useState, useEffect } from "react";
import { MySwal } from "../../../lib/swal";
import axios from "../../../lib/axios";
import errorHandler from "../../../helpers/errorHandler";
import { getIdProvinsi } from "../../../helpers/getIdProvinsi";
import { getIdKota } from "../../../helpers/getIdKota";
import { getIdKecamatan } from "../../../helpers/getIdKecamatan";

const FormEditInfoCorporate = (props) => {
  // console.log(props.user)

  const [provinces, setProvinces] = useState([]);
  const [cities, setCities] = useState([]);
  const [subDistricts, setSubDistricts] = useState([]);
  const [citiesPengiriman, setCitiesPengiriman] = useState([]);
  const [subDistrictsPengiriman, setSubDistrictsPengiriman] = useState([]);

  const user = props.user.Account !== undefined ? props.user : "";
  const [disabled, setDisabled] = useState(false);
  const [required, setRequired] = useState(false);
  const [checkBoxAlamatPengiriman, setcheckBoxAlamatPengiriman] =
    useState(false);
  const [NamaPerusahaan, setNamaPerusahaan] = useState(user.Account.name);
  const [NomorNpwpPerusahaan, setNomorNpwpPerusahaan] = useState(
    user.Account.npwp
  );
  const [FileNpwpPerusahaan, setFileNpwpPerusahaan] = useState(
    user.Account.npwpFile
  );
  const [ProvinsiPerusahaan, setProvinsiPerusahaan] = useState(
    user.Account.billingState
  );
  const [KotaPerusahaan, setKotaPerusahaan] = useState(
    user.Account.billingCity
  );
  const [KecamatanPerusahaan, setKecamatanPerusahaan] = useState(
    user.Account.billingSubdistrict
  );
  const [KodeposPerusahaan, setKodeposPerusahaan] = useState(
    user.Account.billingZip
  );
  const [PatokanPerusahaan, setPatokanPerusahaan] = useState(
    user.Account.billingStreet
  );
  const [ProvinsiPengiriman, setProvinsiPengiriman] = useState(
    user.Account.shippingState
  );
  const [KotaPengiriman, setKotaPengiriman] = useState(
    user.Account.shippingCity
  );
  const [KecamatanPengiriman, setKecamatanPengiriman] = useState(
    user.Account.shippingSubdistrict
  );
  const [KodeposPengiriman, setKodeposPengiriman] = useState(
    user.Account.shippingZip
  );
  const [PatokanPengiriman, setPatokanPengiriman] = useState(
    user.Account.shippingStreet
  );
  const [TeleponPerusahaan, setTeleponPerusahaan] = useState(
    user.Account.phone
  );
  const [JenisPerusahaan, setJenisPerusahaan] = useState(
    user.Account.companyType
  );
  const [KlasifikasiIndustri, setKlasifikasiIndustri] = useState(
    user.Account.industryClassification
  );

  const handleUpdate = async () => {
    try {
      setDisabled(true);
      if (
        NamaPerusahaan.length === 0 &&
        NomorNpwpPerusahaan.length === 0 &&
        FileNpwpPerusahaan.name === undefined &&
        ProvinsiPerusahaan.length === 0 &&
        KotaPerusahaan.length === 0 &&
        KecamatanPerusahaan.length === 0 &&
        KodeposPerusahaan.length === 0 &&
        PatokanPerusahaan.length === 0 &&
        TeleponPerusahaan.length === 0 &&
        JenisPerusahaan.length === 0 &&
        KlasifikasiIndustri.length === 0
      ) {
        setRequired(true);
        MySwal.fire({
          position: "top-end",
          icon: "warning",
          title: "<h2>Oops, Gagal</h2>",
          html: "<h5>Beberapa input tidak boleh kosong!</h5>",
          showConfirmButton: false,
          timer: 3000,
        });
        setDisabled(false);
      } else {
        const formData = new FormData();
        formData.append("firstNamePic", props.user.firstName);
        formData.append("lastNamePic", props.user.lastName);
        formData.append("emailPic", props.user.email);
        formData.append("mobilePhonePic", props.user.mobilePhone);
        formData.append("companyNamePic", props.user.Account.name);
        formData.append("identityTypePic", props.user.identityType);
        formData.append("identityNumberPic", props.user.identityNumber);
        formData.append("jobPic", props.user.job);
        formData.append("jobPositionPic", props.user.jobPosition);
        formData.append("companyName", NamaPerusahaan);
        formData.append("companyType", JenisPerusahaan);
        formData.append("companyIndustryClassification", KlasifikasiIndustri);
        formData.append("companyNpwpNumber", NomorNpwpPerusahaan);
        formData.append("companyEmail", props.user.email);
        formData.append("companyPhone", TeleponPerusahaan);
        formData.append("companyMobilePhone", props.user.mobilePhone);
        formData.append("companyBillingCountry", "Indonesia");
        formData.append("companyBillingState", ProvinsiPerusahaan);
        formData.append("companyBillingCity", KotaPerusahaan);
        formData.append("companyBillingSubdistrict", KecamatanPerusahaan);
        formData.append("companyBillingStreet", PatokanPerusahaan);
        formData.append("companyBillingZip", KodeposPerusahaan);
        formData.append("companyShippingCountry", "Indonesia");
        formData.append("companyShippingState", ProvinsiPengiriman);
        formData.append("companyShippingCity", KotaPengiriman);
        formData.append("companyShippingSubdistrict", KecamatanPengiriman);
        formData.append("companyShippingStreet", PatokanPengiriman);
        formData.append("companyShippingZip", KodeposPengiriman);
        formData.append("companyNpwpFile", FileNpwpPerusahaan);

        // Display the key/value pairs
        // for (var pair of formData.entries()) {
        //     console.log(pair[0] + ', ' + pair[1]);
        // }
        // return false

        const { data } = await axios({
          url: `/users/users`,
          method: "PUT",
          data: formData,
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        });

        // console.log(data)

        if (data.code === "200") {
          setRequired(false);
          MySwal.fire({
            position: "top-end",
            icon: "success",
            title: "<h2>Sukses</h2>",
            html: "<h5>Berhasil menyimpan data!</h5>",
            showConfirmButton: false,
            timer: 3000,
          });
          setTimeout(() => {
            props.close();
            setDisabled(false);
          }, 3000);
        }
      }
    } catch (err) {
      setRequired(true);
      errorHandler({ err: err?.response?.data || err });
      setDisabled(false);
      console.log(err);
    }
  };

  const fetchProvinsi = async () => {
    try {
      const options = {
        url: "/locations/states",
        method: "GET",
      };
      const { data } = await axios(options);
      //   console.log(data);
      setProvinces(data.provinsi);
    } catch (err) {
      if (err) {
        console.log(err?.response?.data);
        // errorHandler({ err: err?.response?.data || err })
      }
    }
  };

  const fetchOneProvinsi = async (flag, idProvinsi) => {
    try {
      const options = {
        url: `/locations/states/${idProvinsi}`,
        method: "GET",
      };
      const { data } = await axios(options);
      if (flag === "first") {
        // dispatch({ type: 'SET_PROVINSI_PERUSAHAAN', 'value': data.data.nama });
      } else {
        // dispatch({ type: 'SET_PROVINSI_PERUSAHAAN_PENGIRIMAN_DOKUMEN', 'value': data.data.nama });
      }
    } catch (err) {
      if (err) {
        console.log(err?.response?.data);
        // errorHandler({ err: err?.response?.data || err })
      }
    }
  };

  const fetchKota = async (idProvinsi) => {
    try {
      const options = {
        url: `/locations/cities?stateId=${idProvinsi}`,
        method: "GET",
      };
      const { data } = await axios(options);
      //   console.log(data);
      setCities(data.kota_kabupaten);
    } catch (err) {
      if (err) {
        console.log(err?.response?.data);
        // errorHandler({ err: err?.response?.data || err })
      }
    }
  };

  const fetchOneKota = async (flag, idKota) => {
    try {
      const options = {
        url: `/locations/cities/${idKota}`,
        method: "GET",
      };
      const { data } = await axios(options);
      if (flag === "first") {
        // dispatch({ type: 'SET_KOTA_PERUSAHAAN', 'value': data.data.nama });
      } else {
        // dispatch({ type: 'SET_KOTA_PERUSAHAAN_PENGIRIMAN_DOKUMEN', 'value': data.data.nama });
      }
    } catch (err) {
      if (err) {
        console.log(err?.response?.data);
        // errorHandler({ err: err?.response?.data || err })
      }
    }
  };

  const fetchSubDistricts = async (idCity) => {
    try {
      const options = {
        url: `/locations/subdistricts?cityId=${idCity}`,
        method: "GET",
      };
      const { data } = await axios(options);
      //   console.log(data);
      setSubDistricts(data.kecamatan);
    } catch (err) {
      if (err) {
        console.log(err?.response?.data);
        // errorHandler({ err: err?.response?.data || err })
      }
    }
  };

  const fetchOneSubDistricts = async (flag, idSubdistricts) => {
    try {
      const options = {
        url: `/locations/subdistricts/${idSubdistricts}`,
        method: "GET",
      };
      const { data } = await axios(options);
      if (flag === "first") {
        // dispatch({ type: 'SET_KECAMATAN_PERUSAHAAN', 'value': data.data.nama });
      } else {
        // dispatch({ type: 'SET_KECAMATAN_PERUSAHAAN_PENGIRIMAN_DOKUMEN', 'value': data.data.nama });
      }
    } catch (err) {
      if (err) {
        console.log(err?.response?.data);
        // errorHandler({ err: err?.response?.data || err })
      }
    }
  };

  const fetchKotaPengiriman = async (idProvinsi) => {
    try {
      const options = {
        url: `/locations/cities?stateId=${idProvinsi}`,
        method: "GET",
      };
      const { data } = await axios(options);
      // console.log(data)
      setCitiesPengiriman(data.kota_kabupaten);
    } catch (err) {
      if (err) {
        console.log(err?.response?.data);
        // errorHandler({ err: err?.response?.data || err })
      }
    }
  };

  const fetchSubDistrictsPengiriman = async (idCity) => {
    try {
      const options = {
        url: `/locations/subdistricts?cityId=${idCity}`,
        method: "GET",
      };
      const { data } = await axios(options);
      // console.log(data)
      setSubDistrictsPengiriman(data.kecamatan);
    } catch (err) {
      if (err) {
        console.log(err?.response?.data);
        // errorHandler({ err: err?.response?.data || err })
      }
    }
  };

  const handleChangeProvinsi = (e, flag) => {
    const province = getIdProvinsi(provinces, e.target.value);

    if (flag === "first") {
      // dispatch({ type: 'SET_PROVINSI_ID_PERUSAHAAN', 'value': e.target.value });
      setProvinsiPerusahaan(e.target.value);
      fetchOneProvinsi("first", province[0].id);
      fetchKota(province[0].id);
    } else {
      // dispatch({ type: 'SET_PROVINSI_ID_PERUSAHAAN_PENGIRIMAN_DOKUMEN', 'value': e.target.value });
      setProvinsiPengiriman(e.target.value);
      fetchOneProvinsi("second", province[0].id);
      fetchKotaPengiriman(province[0].id);
    }
  };

  const handleChangeKota = (e, flag) => {
    const city = getIdKota(cities, e.target.value);
    const shippingCity = getIdKota(citiesPengiriman, e.target.value);

    if (flag === "first") {
      // dispatch({ type: 'SET_KOTA_ID_PERUSAHAAN', 'value': e.target.value });
      setKotaPerusahaan(e.target.value);
      fetchOneKota("first", city[0].id);
      fetchSubDistricts(city[0].id);
    } else {
      // dispatch({ type: 'SET_KOTA_ID_PERUSAHAAN_PENGIRIMAN_DOKUMEN', 'value': e.target.value });
      setKotaPengiriman(e.target.value);
      fetchOneKota("second", shippingCity[0].id);
      fetchSubDistrictsPengiriman(shippingCity[0].id);
    }
  };

  const handleChangeKecamatan = (e, flag) => {
    const subDistrict = getIdKecamatan(subDistricts, e.target.value);
    const shippingSubDistrict = getIdKota(
      subDistrictsPengiriman,
      e.target.value
    );

    if (flag === "first") {
      // dispatch({ type: 'SET_KECAMATAN_ID_PERUSAHAAN', 'value': e.target.value });
      setKecamatanPerusahaan(e.target.value);
      fetchOneSubDistricts("first", subDistrict[0].id);
    } else {
      // dispatch({ type: 'SET_KECAMATAN_ID_PERUSAHAAN_PENGIRIMAN_DOKUMEN', 'value': e.target.value });
      setKecamatanPengiriman(e.target.value);
      fetchOneSubDistricts("second", shippingSubDistrict[0].id);
    }
  };

  const kategoriIndustri = [
    "Pertanian, kehutanan, dan perikanan",
    "Pertambangan dan penggalian",
    "Industri pengolahan",
    "Pengadaan listrik, gas, uap/air panas dan udara dingin",
    "Infrastruktur, utilitas, dan transportasi",
    "Konstruksi",
    "Perdagangan besar dan eceran, reparasi dan perawatan kendaraan",
    "Pengangkutan dan pergudangan",
    "Penyediaan akomodasi dan penyediaan makan minum",
    "Informasi dan komunikasi",
    "Aktivitas keuangan dan asuransi",
    "Real estate",
    "Industri Barang Kebutuhan Konsumen",
    "Administrasi pemerintahan, pertahanan dan jaminan sosial wajib",
    "Pendidikan",
    "NGO",
    "Kesehatan dan Farmasi",
    "Aktivitas sewa guna usaha, ketenagakerjaan, agen perjalanan",
    "Aktivitas industri rumah tangga ",
    "Aktivitas badan internasional dan sejenisnya",
    "Aktivitas profesional, ilmiah, dan teknis",
    "Kesenian, hiburan, dan rekreasi",
    "Food & Beverage",
    "Aktivitas jasa lainnya",
  ];

  useEffect(() => {
    fetchProvinsi();
    fetchKota(user.Account.billingState);
    fetchSubDistricts(user.Account.billingCity);
    fetchKotaPengiriman(user.Account.shippingState);
    fetchSubDistrictsPengiriman(user.Account.shippingCity);
  }, []);

  // console.log(props.user.identityType)

  return (
    <>
      <div className="mb-3 row">
        <p style={{ fontSize: "18px", fontWeight: "700", color: "#3F4254" }}>
          Profil Perusahaan
        </p>
      </div>
      <div className="mb-3 row">
        <div className="col-lg-4">
          <label
            style={{
              fontSize: "15px",
              color:
                NamaPerusahaan.length === 0 && required === true
                  ? "#F1416C"
                  : "#191919",
              fontWeight: "500",
            }}
            htmlFor="namaPerusahaan"
            className="col-form-label required"
          >
            Nama Perusahaan
          </label>
        </div>
        <div className="col-lg-8">
          <input
            style={{
              fontSize: "14px",
              borderColor:
                NamaPerusahaan.length === 0 && required === true
                  ? "#F1416C"
                  : "",
              fontWeight: "500",
            }}
            type="text"
            className="form-control form-control-white"
            id="namaPerusahaan"
            onChange={(e) => setNamaPerusahaan(e.target.value)}
            value={NamaPerusahaan}
          />
        </div>
      </div>
      <div className="mb-3 row">
        <div className="col-lg-4">
          <label
            style={{
              fontSize: "15px",
              color:
                NomorNpwpPerusahaan.length === 0 && required === true
                  ? "#F1416C"
                  : "#191919",
              fontWeight: "500",
            }}
            htmlFor="stringNpwpPerusahaan"
            className="col-form-label required"
          >
            Nomor NPWP Perusahaan
          </label>
        </div>
        <div className="col-lg-8">
          <input
            style={{
              fontSize: "14px",
              borderColor:
                NomorNpwpPerusahaan.length === 0 && required === true
                  ? "#F1416C"
                  : "",
              fontWeight: "500",
            }}
            type="text"
            className="form-control form-control-white"
            id="stringNpwpPerusahaan"
            onChange={(e) => setNomorNpwpPerusahaan(e.target.value)}
            value={NomorNpwpPerusahaan}
          />
        </div>
      </div>
      <div className="mb-3 row">
        <div className="col-lg-4">
          <label
            style={{
              fontSize: "15px",
              color:
                FileNpwpPerusahaan.name === undefined && required === true
                  ? "#F1416C"
                  : "#191919",
              fontWeight: "500",
            }}
            htmlFor="fileNpwpPerusahaan"
            className="col-form-label required"
          >
            Upload NPWP Perusahaan
          </label>
        </div>
        <div className="col-lg-8">
          <input
            style={{
              fontSize: "14px",
              borderColor:
                FileNpwpPerusahaan.name === undefined && required === true
                  ? "#F1416C"
                  : "",
              fontWeight: "500",
            }}
            type="file"
            className="form-control form-control-white"
            id="fileNpwpPerusahaan"
            onChange={(e) => setFileNpwpPerusahaan(e.target.files[0])}
          />
          <p
            className="mt-2"
            style={{ fontSize: "12px", color: "#5E6278", fontWeight: "500" }}
          >
            &nbsp;Format File .PDF, .PNG, .JPG, .JPEG
          </p>
          {FileNpwpPerusahaan.nama !== undefined ? (
            <div
              className="mb-3"
              style={{ color: "#0C86D9", fontWeight: "500" }}
            >
              {FileNpwpPerusahaan &&
                `${FileNpwpPerusahaan.name} - ${FileNpwpPerusahaan.type}`}
            </div>
          ) : (
            <a
              href={FileNpwpPerusahaan}
              download="FileNpwpPerusahaan"
              target="_blank"
              className="badge bg-success"
            >
              Unduh
            </a>
          )}
        </div>
      </div>
      <div className="mb-3 row">
        <div className="col-lg-4">
          <label
            style={{ fontSize: "15px", color: "#191919", fontWeight: "500" }}
            className="col-form-label required"
          >
            Alamat Perusahaan
          </label>
        </div>
        <div className="row col-lg-8">
          <div className="col-lg-6 mb-3">
            {/* <label style={{ fontSize: '15px', color: (ProvinsiPerusahaan.length === 0 && required === true) ? '#F1416C' : '#191919', fontWeight: '500' }} htmlFor="ProvinsiCorporate" className="col-form-label">Provinsi</label>
                        <input style={{ fontSize: '14px', borderColor: (ProvinsiPerusahaan.length === 0 && required === true) ? '#F1416C' : '', fontWeight: '500' }} type="text" className="form-control form-control-white" id="ProvinsiCorporate" onChange={(e) => setProvinsiPerusahaan(e.target.value)} value={ProvinsiPerusahaan} /> */}
            <label
              style={{
                fontSize: "15px",
                color:
                  ProvinsiPerusahaan.length === 0 && required === true
                    ? "#F1416C"
                    : "#191919",
                fontWeight: "500",
              }}
              htmlFor="ProvinsiCorporate"
              className="col-form-label"
            >
              Provinsi
            </label>
            <select
              className="form-select"
              aria-label="Select example"
              id="ProvinsiCorporate"
              onChange={(e) => handleChangeProvinsi(e, "first")}
              value={ProvinsiPerusahaan}
              style={{
                borderColor:
                  ProvinsiPerusahaan.length === 0 && required === true
                    ? "#F1416C"
                    : "",
              }}
            >
              <option value="">Pilih</option>
              {provinces.map((p, i) => (
                <option key={i} value={p.nama}>
                  {p.nama}
                </option>
              ))}
            </select>
          </div>
          <div className="col-lg-6 mb-3">
            {/* <label style={{ fontSize: '15px', color: (KotaPerusahaan.length === 0 && required === true) ? '#F1416C' : '#191919', fontWeight: '500' }} htmlFor="KotaCorporate" className="col-form-label">Kota</label>
                        <input style={{ fontSize: '14px', borderColor: (KotaPerusahaan.length === 0 && required === true) ? '#F1416C' : '', fontWeight: '500' }} type="text" className="form-control form-control-white" id="KotaCorporate" onChange={(e) => setKotaPerusahaan(e.target.value)} value={KotaPerusahaan} /> */}
            <label
              style={{
                fontSize: "15px",
                color:
                  KotaPerusahaan.length === 0 && required === true
                    ? "#F1416C"
                    : "#191919",
                fontWeight: "500",
              }}
              htmlFor="KotaCorporate"
              className="col-form-label"
            >
              Kota
            </label>
            <select
              className="form-select"
              aria-label="Select example"
              id="KotaCorporate"
              onChange={(e) => handleChangeKota(e, "first")}
              value={KotaPerusahaan}
              style={{
                borderColor:
                  KotaPerusahaan.length === 0 && required === true
                    ? "#F1416C"
                    : "",
              }}
            >
              <option value="">Pilih</option>
              {cities.length === 0 ? (
                <option key={1} value={KotaPerusahaan}>
                  {KotaPerusahaan}
                </option>
              ) : (
                cities.map((c, i) => (
                  <option key={i} value={c.nama}>
                    {c.nama}
                  </option>
                ))
              )}
            </select>
          </div>
          <div className="col-lg-6 mb-3">
            {/* <label style={{ fontSize: '15px', color: (KecamatanPerusahaan.length === 0 && required === true) ? '#F1416C' : '#191919', fontWeight: '500' }} htmlFor="KecamatanCorporate" className="col-form-label">Kecamatan</label>
                        <input style={{ fontSize: '14px', borderColor: (KecamatanPerusahaan.length === 0 && required === true) ? '#F1416C' : '', fontWeight: '500' }} type="text" className="form-control form-control-white" id="KecamatanCorporate" onChange={(e) => setKecamatanPerusahaan(e.target.value)} value={KecamatanPerusahaan} /> */}
            <label
              style={{
                fontSize: "15px",
                color:
                  KecamatanPerusahaan.length === 0 && required === true
                    ? "#F1416C"
                    : "#191919",
                fontWeight: "500",
              }}
              htmlFor="KecamatanCorporate"
              className="col-form-label"
            >
              Kecamatan
            </label>
            <select
              className="form-select"
              aria-label="Select example"
              id="KecamatanCorporate"
              onChange={(e) => handleChangeKecamatan(e, "first")}
              value={KecamatanPerusahaan}
              style={{
                borderColor:
                  KecamatanPerusahaan.length === 0 && required === true
                    ? "#F1416C"
                    : "",
              }}
            >
              <option value="">Pilih</option>
              {subDistricts.length === 0 ? (
                <option key={1} value={KecamatanPerusahaan}>
                  {KecamatanPerusahaan}
                </option>
              ) : (
                subDistricts.map((d, i) => (
                  <option key={i} value={d.nama}>
                    {d.nama}
                  </option>
                ))
              )}
            </select>
          </div>
          <div className="col-lg-6 mb-3">
            <label
              style={{
                fontSize: "15px",
                color:
                  KodeposPerusahaan.length === 0 && required === true
                    ? "#F1416C"
                    : "#191919",
                fontWeight: "500",
              }}
              htmlFor="KodeposCorporate"
              className="col-form-label"
            >
              Kode Pos
            </label>
            <input
              style={{
                fontSize: "14px",
                borderColor:
                  KodeposPerusahaan.length === 0 && required === true
                    ? "#F1416C"
                    : "",
                fontWeight: "500",
              }}
              type="text"
              className="form-control form-control-white"
              id="KodeposCorporate"
              onChange={(e) => setKodeposPerusahaan(e.target.value)}
              value={KodeposPerusahaan}
            />
          </div>
          <div className="col-lg-12">
            <label
              style={{
                fontSize: "15px",
                color:
                  PatokanPerusahaan.length === 0 && required === true
                    ? "#F1416C"
                    : "#191919",
                fontWeight: "500",
              }}
              htmlFor="PatokanAlamatPerusahaan"
              className="col-form-label"
            >
              Nama Jalan, Gedung, Nomor/Blok
            </label>
            <input
              style={{
                fontSize: "14px",
                borderColor:
                  PatokanPerusahaan.length === 0 && required === true
                    ? "#F1416C"
                    : "",
                fontWeight: "500",
              }}
              type="text"
              className="form-control form-control-white"
              id="PatokanAlamatPerusahaan"
              onChange={(e) => setPatokanPerusahaan(e.target.value)}
              value={PatokanPerusahaan}
            />
          </div>
          <div className="col-lg-12 mt-3">
            <label className="form-check form-check-custom form-check-solid">
              <input
                className="form-check-input"
                type="checkbox"
                defaultValue
                onClick={() =>
                  setcheckBoxAlamatPengiriman(!checkBoxAlamatPengiriman)
                }
              />
              <span className="form-check-label">
                Alamat Pengiriman Dokumen berbeda dengan Alamat Perusahaan
              </span>
            </label>
          </div>
        </div>
      </div>
      {checkBoxAlamatPengiriman === true ? (
        <div className="mb-4 row">
          <div className="col-lg-4">
            <label
              style={{ fontSize: "15px", color: "#191919", fontWeight: "500" }}
              className="col-form-label"
            >
              Alamat Pengiriman Dokumen
            </label>
          </div>
          <div className="row col-lg-8">
            <div className="col-lg-6 mb-3">
              {/* <label style={{ fontSize: '15px', color: '#191919', fontWeight: '500' }} htmlFor="ProvinsiCorporatePengiriman" className="col-form-label">Provinsi</label>
                                <input style={{ fontSize: '14px', fontWeight: '500' }} type="text" className="form-control form-control-white" id="ProvinsiCorporatePengiriman" onChange={(e) => setProvinsiPengiriman(e.target.value)} value={ProvinsiPengiriman} /> */}
              <label
                style={{
                  fontSize: "15px",
                  color:
                    ProvinsiPengiriman.length === 0 && required === true
                      ? "#F1416C"
                      : "#191919",
                  fontWeight: "500",
                }}
                htmlFor="ProvinsiCorporatePengiriman"
                className="col-form-label"
              >
                Provinsi
              </label>
              <select
                className="form-select"
                aria-label="Select example"
                id="ProvinsiCorporatePengiriman"
                onChange={(e) => handleChangeProvinsi(e, "second")}
                value={ProvinsiPengiriman}
                style={{
                  borderColor:
                    ProvinsiPengiriman.length === 0 && required === true
                      ? "#F1416C"
                      : "",
                }}
              >
                <option value="">Pilih</option>
                {provinces.map((p, i) => (
                  <option key={i} value={p.nama}>
                    {p.nama}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-lg-6 mb-3">
              {/* <label style={{ fontSize: '15px', color: '#191919', fontWeight: '500' }} htmlFor="KotaCorporatePengiriman" className="col-form-label">Kota</label>
                                <input style={{ fontSize: '14px', fontWeight: '500' }} type="text" className="form-control form-control-white" id="KotaCorporatePengiriman" onChange={(e) => setKotaPengiriman(e.target.value)} value={KotaPengiriman} /> */}
              <label
                style={{
                  fontSize: "15px",
                  color:
                    KotaPengiriman.length === 0 && required === true
                      ? "#F1416C"
                      : "#191919",
                  fontWeight: "500",
                }}
                htmlFor="KotaCorporatePengiriman"
                className="col-form-label"
              >
                Kota
              </label>
              <select
                className="form-select"
                aria-label="Select example"
                id="KotaCorporatePengiriman"
                onChange={(e) => handleChangeKota(e, "second")}
                value={KotaPengiriman}
                style={{
                  borderColor:
                    KotaPengiriman.length === 0 && required === true
                      ? "#F1416C"
                      : "",
                }}
              >
                <option value="">Pilih</option>
                {citiesPengiriman.length === 0 ? (
                  <option key={1} value={KotaPengiriman}>
                    {KotaPengiriman}
                  </option>
                ) : (
                  citiesPengiriman.map((c, i) => (
                    <option key={i} value={c.nama}>
                      {c.nama}
                    </option>
                  ))
                )}
              </select>
            </div>
            <div className="col-lg-6 mb-3">
              {/* <label style={{ fontSize: '15px', color: '#191919', fontWeight: '500' }} htmlFor="KecamatanCorporatePengiriman" className="col-form-label">Kecamatan</label>
                                <input style={{ fontSize: '14px', fontWeight: '500' }} type="text" className="form-control form-control-white" id="KecamatanCorporatePengiriman" onChange={(e) => setKecamatanPengiriman(e.target.value)} value={KecamatanPengiriman} /> */}
              <label
                style={{
                  fontSize: "15px",
                  color:
                    KecamatanPengiriman.length === 0 && required === true
                      ? "#F1416C"
                      : "#191919",
                  fontWeight: "500",
                }}
                htmlFor="KecamatanCorporatePengiriman"
                className="col-form-label"
              >
                Kecamatan
              </label>
              <select
                className="form-select"
                aria-label="Select example"
                id="KecamatanCorporatePengiriman"
                onChange={(e) => handleChangeKecamatan(e, "second")}
                value={KecamatanPengiriman}
                style={{
                  borderColor:
                    KecamatanPengiriman.length === 0 && required === true
                      ? "#F1416C"
                      : "",
                }}
              >
                <option value="">Pilih</option>
                {subDistrictsPengiriman.length === 0 ? (
                  <option key={1} value={KecamatanPengiriman}>
                    {KecamatanPengiriman}
                  </option>
                ) : (
                  subDistrictsPengiriman.map((c, i) => (
                    <option key={i} value={c.nama}>
                      {c.nama}
                    </option>
                  ))
                )}
              </select>
            </div>
            <div className="col-lg-6 mb-3">
              <label
                style={{
                  fontSize: "15px",
                  color: "#191919",
                  fontWeight: "500",
                }}
                htmlFor="KodeposCorporatePengiriman"
                className="col-form-label"
              >
                Kode Pos
              </label>
              <input
                style={{ fontSize: "14px", fontWeight: "500" }}
                type="text"
                className="form-control form-control-white"
                id="KodeposCorporate"
                onChange={(e) => setKodeposPengiriman(e.target.value)}
                value={KodeposPengiriman}
              />
            </div>
            <div className="col-lg-12">
              <label
                style={{
                  fontSize: "15px",
                  color: "#191919",
                  fontWeight: "500",
                }}
                htmlFor="PatokanAlamatPerusahaanPengiriman"
                className="col-form-label"
              >
                Nama Jalan, Gedung, Nomor/Blok
              </label>
              <input
                style={{ fontSize: "14px", fontWeight: "500" }}
                type="text"
                className="form-control form-control-white"
                id="PatokanAlamatPerusahaanPengiriman"
                onChange={(e) => setPatokanPengiriman(e.target.value)}
                value={PatokanPengiriman}
              />
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
      <div className="mb-3 row">
        <div className="col-lg-4">
          <label
            style={{
              fontSize: "15px",
              color:
                TeleponPerusahaan.length === 0 && required === true
                  ? "#F1416C"
                  : "#191919",
              fontWeight: "500",
            }}
            htmlFor="TeleponPerusahaan"
            className="col-form-label required"
          >
            Telepon Perusahaan
          </label>
        </div>
        <div className="col-lg-8">
          <input
            style={{
              fontSize: "14px",
              borderColor:
                TeleponPerusahaan.length === 0 && required === true
                  ? "#F1416C"
                  : "",
              fontWeight: "500",
            }}
            type="text"
            className="form-control form-control-white"
            id="TeleponPerusahaan"
            onChange={(e) => setTeleponPerusahaan(e.target.value)}
            value={TeleponPerusahaan}
          />
        </div>
      </div>
      <div className="mb-3 row">
        <div className="col-lg-4">
          <label
            style={{
              fontSize: "15px",
              color:
                JenisPerusahaan.length === 0 && required === true
                  ? "#F1416C"
                  : "#191919",
              fontWeight: "500",
            }}
            htmlFor="jenisPerusahaan"
            className="col-form-label required"
          >
            Jenis Perusahaan
          </label>
        </div>
        <div className="col-lg-8">
          <select
            className="form-select"
            aria-label="Select example"
            id="jenisPerusahaan"
            onChange={(e) => setJenisPerusahaan(e.target.value)}
            value={JenisPerusahaan}
            style={{
              fontSize: "14px",
              borderColor:
                JenisPerusahaan.length === 0 && required === true
                  ? "#F1416C"
                  : "",
              fontWeight: "500",
            }}
          >
            <option value="">Pilih</option>
            <option value="PT">PT (Perseroan Terbatas)</option>
            <option value="CV">CV (Persekutuan Komanditer)</option>
            <option value="BUMN">Perusahaan Negara</option>
            <option value="Koperasi">Koperasi</option>
            <option value="Persero">Persero</option>
            <option value="Perseorangan">Perusahaan Perseorangan</option>
            <option value="Firma">Persekutuan Firma</option>
          </select>
        </div>
      </div>
      <div className="mb-3 row">
        <div className="col-lg-4">
          <label
            style={{
              fontSize: "15px",
              color:
                KlasifikasiIndustri.length === 0 && required === true
                  ? "#F1416C"
                  : "#191919",
              fontWeight: "500",
            }}
            htmlFor="klasifikasiPerusahaan"
            className="col-form-label required"
          >
            Klasifikasi Industri
          </label>
        </div>
        <div className="col-lg-8">
          <select
            className="form-select"
            aria-label="Select example"
            id="KlasifikasiIndustri"
            onChange={(e) => setKlasifikasiIndustri(e.target.value)}
            value={KlasifikasiIndustri}
            style={{
              fontSize: "14px",
              borderColor:
                KlasifikasiIndustri.length === 0 && required === true
                  ? "#F1416C"
                  : "",
              fontWeight: "500",
            }}
          >
            <option value="">Pilih</option>
            {kategoriIndustri.map((k, i) => (
              <option key={i} value={k}>
                {k}
              </option>
            ))}
          </select>
        </div>
      </div>
      <hr></hr>
      <div className="mb-3 row d-flex" style={{ textAlign: "right" }}>
        <div>
          <button
            onClick={() => props.close()}
            className="btn btn-bg-white"
            style={{ marginRight: "10px" }}
          >
            Batal
          </button>
          <button
            onClick={handleUpdate}
            className="btn btn-success"
            disabled={disabled}
          >
            {disabled === true ? "Mohon tunggu..." : "Simpan Perubahan"}
          </button>
        </div>
      </div>
    </>
  );
};

export default FormEditInfoCorporate;
